import { render, staticRenderFns } from "./RinnovaPraticheDaUfficio.vue?vue&type=template&id=530bbd06&scoped=true&"
import script from "./RinnovaPraticheDaUfficio.vue?vue&type=script&lang=js&"
export * from "./RinnovaPraticheDaUfficio.vue?vue&type=script&lang=js&"
import style0 from "./RinnovaPraticheDaUfficio.vue?vue&type=style&index=0&id=530bbd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bbd06",
  null
  
)

export default component.exports
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerHourglass,QBtn,QCheckbox});
